// src/components/Login.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosConfig';
import { AuthContext } from '../context/AuthContext';
import { Link } from 'react-router-dom';

function Login() {
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' })); // Clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axiosInstance
      .post('/api/v1/login/', formData)
      .then((response) => {
        const { access, refresh } = response.data;
        loginUser(access);
        localStorage.setItem('refresh_token', refresh);
        
        // Redirect to home page
        navigate('/chess', { state: { username: formData.username } });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          setErrors(error.response.data);
        } else {
          console.error('An unexpected error occurred:', error);
        }
      });
  };

  return (
    <div className="container">
      <div className="jumbotron">
        <h1>Login</h1>
        <form onSubmit={handleSubmit} noValidate>
          {/* Non-field Errors */}
          {errors.detail && <div className="alert alert-danger">{errors.detail}</div>}

          {/* Username */}
          <div className="form-group">
            <label htmlFor="id_username">Username:</label>
            <input
              type="text"
              className={`form-control ${errors.username ? 'is-invalid' : ''}`}
              name="username"
              id="id_username"
              value={formData.username}
              onChange={handleChange}
              required
            />
            {errors.username && <div className="invalid-feedback">{errors.username}</div>}
          </div>

          {/* Password */}
          <div className="form-group">
            <label htmlFor="id_password">Password:</label>
            <input
              type="password"
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              name="password"
              id="id_password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary">
            Login
          </button>
        </form>
        <p>
        Click <Link to="/join">here</Link> to join.
        </p>
      </div>
    </div>
  );
}

export default Login;
